import {Component, OnInit, Input, ElementRef, HostListener, HostBinding} from '@angular/core'
import {Router, ActivatedRoute} from '@angular/router'
import {ProjectService} from 'app/project/project.service'

const BREAKPOINTS = [/*920, 765, */ 610, 455, 300, 145]
const ICONS = {
  image: 'photo', // photo
  text: 'html5',
  default: 'attach_file',
  video: 'videocam',
  // public: 'visibility', // don't show icon by default
  internal: 'visibility_off',
  archived: 'archive',
}

@Component({
  selector: 'app-creative-preview',
  templateUrl: './creative-preview.component.html',
  styleUrls: ['./creative-preview.component.scss'],
})
export class CreativePreviewComponent implements OnInit {
  @Input() creative
  date: string
  icon: string
  visibility: string
  width
  height
  fallback
  colors = {
    INTERNAL_REVIEW_READY: '#5FADD5',
    CLIENT_REVIEW_READY: '#FBE470',
    REVISION_REQUESTED: '#E6515B',
    APPROVED: '#6DD982',
    KILLED: '#0003',
  }

  constructor(private elRef: ElementRef, private router: Router, private route: ActivatedRoute, public projectService: ProjectService) {}

  ngOnInit() {
    this.date = new Date(this.creative.date).toLocaleDateString(undefined, {
      // weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
    this.icon = ICONS[this.creative.type.split('/')[0]] || ICONS.default
    this.visibility = ICONS[this.creative.visibility] || ''

    const dimensions = this.creative.name.match(/\d+x\d+/) ? this.creative.name.match(/\d+x\d+/)[0].split('x') : [300, 0]

    this.width = dimensions[0]
    this.height = dimensions[1]

    const display_width = this.getDisplayWidth()
    const scale = display_width / dimensions[0]

    this.width = dimensions[0] * scale
    this.height = dimensions[1] * scale

    this.elRef.nativeElement.style.setProperty('--width', this.width + 'px')

    this.fallback = this.creative.fallback || `https://place-hold.it/${this.creative.width}x${this.creative.height}`
    // /${this.branding.color_shade[0].replace('#','')}
    // /${this.branding.color_shade[1].replace('#', '')}
  }

  @HostListener('click', ['$event'])
  onClick(event) {
    if (this.focused) {
      this.router.navigate(['./creative', this.creative.id], {
        relativeTo: this.route,
      })
      this.projectService.focused = this.projectService.focused.filter(c => c !== this.creative.id)
      // this.focused = false
    }
  }

  @HostListener('focus', ['$event'])
  onFocus(event) {
    if (!this.projectService.metaKey) this.projectService.focused = []
    this.focused = true
  }

  getDisplayWidth() {
    // if (window.innerWidth < 768) return Math.min(window.innerWidth, this.width)
    // console.log(window.innerWidth)
    const parent = this.elRef.nativeElement.parentElement.getBoundingClientRect()
    const width = this.width > parent.width ? parent.width : this.width
    const breakpoints = BREAKPOINTS.filter(breakpoint => {
      return breakpoint < parent.width
    })
    for (let i = 0; i < breakpoints.length - 1; i++) {
      if (width >= breakpoints[i]) return breakpoints[i]
    }
    return width > breakpoints[breakpoints.length - 1] ? breakpoints[breakpoints.length - 1] : width
  }

  @HostBinding('class.focused')
  get focused() {
    return this.projectService.focused.includes(this.creative.id)
  }

  set focused(value) {
    if (value) {
      setTimeout(() => {
        this.projectService.focused.push(this.creative.id)
      }, 200)
    }
    // else
    //   this.projectService.focused = this.projectService.focused.filter(
    //     c => c !== this.creative.id
    //   )
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/creative/creative-preview/creative-preview.component.ts